/* tslint:disable:indent */
import { EventEmitter, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { BehaviorSubject, EMPTY, Observable, of, Subscription, timer } from 'rxjs';
import {filter, first, map, switchMap, tap, take, delay, catchError, finalize} from 'rxjs/operators';
import { Avis } from '../../../../models/avis';
import { ToasterMessage } from '../../../shared/models/component-messages/toastr/toastr-message';
import { AutoCompleteService } from '../../../shared/services/auto-complete.service';
import { FormExtractorService } from '../../../shared/services/form-extractor.service';
import { LogService } from '../../../shared/services/log.service';
import { FacturationApiService } from '../../services/facturation.api.service';
import { FormulaireServiceService } from '../../services/formulaire-service.service';
import { EformConditionsV2Service } from '../../eforms/services/eform-conditions-v2.service';
import { CTRL_1002 } from '../../validators/1002/ctrl1002';
import { CTRL_1019 } from '../../validators/1019/ctrl1019';
import { CTRL_1020 } from '../../validators/1020/ctrl1020';
import { CTRL_1028 } from '../../validators/1028/ctrl1028';
import { CTRL_107 } from '../../validators/107/ctrl107';
import { CTRL_1101 } from '../../validators/1101/ctrl1101';
import { CTRL_1103 } from '../../validators/1103/ctrl1103';
import { CTRL_1106 } from '../../validators/1106/ctrl1106';
import { CTRL_1108 } from '../../validators/1108/ctrl1108';
import { CTRL_1111 } from '../../validators/1111/ctrl1111';
import { CTRL_1112 } from '../../validators/1112/ctrl1112';
import { CTRL_1162 } from '../../validators/1162/ctrl1162';
import { CTRL_1164 } from '../../validators/1164/ctrl1164';
import { CTRL_1169 } from '../../validators/1169/ctrl1169';
import { CTRL_1198 } from '../../validators/1198/ctrl1198';
import { CTRL_1200 } from '../../validators/1200/ctrl1200';
import { CTRL_1203 } from '../../validators/1203/ctrl1203';
import { CTRL_1206 } from '../../validators/1206/ctrl1206';
import { CTRL_1211 } from '../../validators/1211/ctrl1211';
import { CTRL_1222 } from '../../validators/1222/ctrl1222';
import { CTRL_123 } from '../../validators/123/ctrl123';
import { CTRL_14 } from '../../validators/14/ctrl14';
import { CTRL_15 } from '../../validators/15/ctrl15';
import { CTRL_16 } from '../../validators/16/ctrl16';
import { CTRL_175 } from '../../validators/175/ctrl175';
import { CTRL_176 } from '../../validators/176/ctrl176';
import { CTRL_18 } from '../../validators/18/ctrl18';
import { CTRL_19 } from '../../validators/19/ctrl19';
import { CTRL_20 } from '../../validators/20/ctrl20';
import { CTRL_202 } from '../../validators/202/ctrl202';
import { CTRL_203 } from '../../validators/203/ctrl203';
import { CTRL_204 } from '../../validators/204/ctrl204';
import { CTRL_205 } from '../../validators/205/ctrl205';
import { CTRL_221 } from '../../validators/221/ctrl221';
import { CTRL_237 } from '../../validators/237/ctrl237';
import { CTRL_24 } from '../../validators/24/ctrl24';
import { CTRL_252 } from '../../validators/252/ctrl252';
import { CTRL_263 } from '../../validators/263/ctrl263';
import { CTRL_28_1 } from '../../validators/28/ctrl28_1';
import { CTRL_28_2 } from '../../validators/28/ctrl28_2';
import { CTRL_28_3 } from '../../validators/28/ctrl28_3';
import { CTRL_29 } from '../../validators/29/ctrl29';
import { CTRL_31 } from '../../validators/31/ctrl31';
import { CTRL_322 } from '../../validators/322/ctrl322';
import { CTRL_33 } from '../../validators/33/ctrl33';
import { CTRL_331 } from '../../validators/331/ctrl331';
import { CTRL_334 } from '../../validators/334/ctrl334';
import { CTRL_34 } from '../../validators/34/ctrl34';
import { CTRL_36 } from '../../validators/36/ctrl36';
import { CTRL_38 } from '../../validators/38/ctrl38';
import { CTRL_40 } from '../../validators/40/ctrl40';
import { CTRL_403 } from '../../validators/403/ctrl403';
import { CTRL_406 } from '../../validators/406/ctrl406';
import { CTRL_410 } from '../../validators/410/ctrl410';
import { CTRL_411_def } from '../../validators/411/ctrl411_def';
import { CTRL_417 } from '../../validators/417/ctrl417';
import { CTRL_418 } from '../../validators/418/ctrl418';
import { CTRL_426 } from '../../validators/426/ctrl426';
import { CTRL_427 } from '../../validators/427/ctrl427';
import { CTRL_429 } from '../../validators/429/ctrl429';
import { CTRL_43 } from '../../validators/43/ctrl43';
import { CTRL_430 } from '../../validators/430/ctrl430';
import { CTRL_432 } from '../../validators/432/ctrl432';
import { CTRL_438 } from '../../validators/438/ctrl438';
import { CTRL_439 } from '../../validators/439/ctrl439';
import { CTRL_442 } from '../../validators/442/ctrl442';
import { CTRL_444 } from '../../validators/444/ctrl444';
import { CTRL_445 } from '../../validators/445/ctrl445';
import { CTRL_446 } from '../../validators/446/ctrl446';
import { CTRL_467 } from '../../validators/467/ctrl467';
import { CTRL_468 } from '../../validators/468/ctrl468';
import { CTRL_469 } from '../../validators/469/ctrl469';
import { CTRL_471 } from '../../validators/471/ctrl471';
import { CTRL_473 } from '../../validators/473/ctrl473';
import { CTRL_474 } from '../../validators/474/ctrl474';
import { CTRL_48 } from '../../validators/48/ctrl48';
import { CTRL_49 } from '../../validators/49/ctrl49';
import { CTRL_494 } from '../../validators/494/ctrl494';
import { CTRL_495 } from '../../validators/495/ctrl495';
import { CTRL_496 } from '../../validators/496/ctrl496';
import { CTRL_499 } from '../../validators/499/ctrl499';
import { CTRL_500 } from '../../validators/500/ctrl500';
import { CTRL_500u2 } from '../../validators/500_2/ctrl500_2';
import { CTRL_503 } from '../../validators/503/ctrl503';
import { CTRL_517 } from '../../validators/517/ctrl517';
import { CTRL_522 } from '../../validators/522/ctrl522';
import { CTRL_524 } from '../../validators/524/ctrl524';
import { CTRL_525 } from '../../validators/525/ctrl525';
import { CTRL_525u2 } from '../../validators/525_2/ctrl525';
import { CTRL_526 } from '../../validators/526/ctrl526';
import { CTRL_526u2 } from '../../validators/526_2/ctrl526';
import { CTRL_527 } from '../../validators/527/ctrl527';
import { CTRL_528 } from '../../validators/528/ctrl528';
import { CTRL_529 } from '../../validators/529/ctrl529';
import { CTRL_57 } from '../../validators/57/ctrl57';
import { CTRL_626_def } from '../../validators/626/ctrl626_def';
import { CTRL_629 } from '../../validators/629/ctrl629';
import { CTRL_630 } from '../../validators/630/ctrl630';
import { CTRL_637 } from '../../validators/637/ctrl637';
import { CTRL_65 } from '../../validators/65/ctrl65';
import { CTRL_651 } from '../../validators/651/ctrl651';
import { CTRL_654 } from '../../validators/654/ctrl654';
import { CTRL_664 } from '../../validators/664/ctrl664';
import { CTRL_69 } from '../../validators/69/ctrl69';
import { CTRL_672 } from '../../validators/672/ctrl672';
import { CTRL_73 } from '../../validators/73/ctrl73';
import { CTRL_740 } from '../../validators/740/ctrl740';
import { CTRL_742 } from '../../validators/742/ctrl742';
import { CTRL_746 } from '../../validators/746/ctrl746';
import { CTRL_760 } from '../../validators/760/ctrl760';
import { CTRL_77 } from '../../validators/77/ctrl77';
import { CTRL_772 } from '../../validators/772/ctrl772';
import { CTRL_774 } from '../../validators/774/ctrl774';
import { CTRL_778 } from '../../validators/778/ctrl778';
import { CTRL_795 } from '../../validators/795/ctrl795';
import { CTRL_797 } from '../../validators/797/ctrl797';
import { CTRL_8 } from '../../validators/8/ctrl8';
import { CTRL_805 } from '../../validators/805/ctrl805';
import { CTRL_806 } from '../../validators/806/ctrl806';
import { CTRL_812 } from '../../validators/812/ctrl812';
import { CTRL_870 } from '../../validators/870/ctrl870';
import { CTRL_9 } from '../../validators/9/ctrl9';
import { CTRL_9201 } from '../../validators/9201/ctrl9201';
import { CTRL_966 } from '../../validators/966/ctrl966';
import { CTRL_NAME_EXTRACTOR } from '../../validators/ctrl.name.extractor';
import { CTRL_DATE } from '../../validators/DATE/ctrlDate';
import { CTRL_1024 } from '../../validators/horsDef/1024/ctrl1024';
import { CTRL_1025 } from '../../validators/horsDef/1025/ctrl1025';
import { CTRL_1027 } from '../../validators/horsDef/1027/ctrl1027';
import { CTRL_103 } from '../../validators/horsDef/103/ctrl103';
import { CTRL_1086 } from '../../validators/horsDef/1086/ctrl1086';
import { CTRL_1087 } from '../../validators/horsDef/1087/ctrl1087';
import { CTRL_1120 } from '../../validators/horsDef/1120/ctrl1120';
import { CTRL_120 } from '../../validators/horsDef/120/ctrl120';
import { CTRL_21 } from '../../validators/horsDef/21/ctrl21';
import { CTRL_215 } from '../../validators/horsDef/215/ctrl215';
import { CTRL_286 } from '../../validators/horsDef/286/ctrl286';
import { CTRL_290 } from '../../validators/horsDef/290/ctrl290';
import { CTRL_292 } from '../../validators/horsDef/292/ctrl292';
import { CTRL_299 } from '../../validators/horsDef/299/ctrl299';
import { CTRL_380 } from '../../validators/horsDef/380/ctrl380';
import { CTRL_411_horsDef } from '../../validators/horsDef/411/ctrl411_horsDef';
import { CTRL_621_horsDef } from '../../validators/horsDef/621/ctrl621_horsDef';
import { CTRL_625 } from '../../validators/horsDef/625/ctrl625';
import { CTRL_626_horsDef } from '../../validators/horsDef/626/ctrl626_horsDef';
import { CTRL_MONEY } from '../../validators/MONEY/ctrlMONEY';
import { CTRL_270 } from '../../validators/270/ctrl270';
import { CTRL_274 } from '../../validators/274/ctrl274';
import { CTRL_ADR } from '../../validators/adr/ctrlADR';
import { CTRL_11 } from '../../validators/11/ctrl11';
import { CTRL_416 } from '../../validators/416/ctrl416';
import { CTRL_72 } from '../../validators/72/ctrl72';
import { CTRL_754 } from '../../validators/754/ctrl754';
import { CTRL_813 } from '../../validators/813/ctrl813';
import { CTRL_416HorsDef } from '../../validators/horsDef/416/ctrl416_horsDef';
import { CTRL_TRIM } from '../../validators/TRIM/ctrlTRIM';
import { ContenuPdf } from '../models/contenuPdf';
import { FormsMapper } from '../../../../models/enums/forms.enum';
import { CTRL_419 } from '../../validators/419/ctrl419';
import { CTRL_621 } from '../../validators/621/ctrl621';
import { ErrorWafConverterService } from '../../../shared/services/error-waf-converter.service';
import { CTRL_1204 } from '../../validators/1204/ctrl1204';
import { CTRL_1216 } from '../../validators/1216/ctrl1216';
import { CTRL_268 } from '../../validators/268/ctrl268';
import { IdWebApiService } from '../../services/idweb.api.service';
import { CTRL_2000 } from '../../validators/newRG/2000/ctrl2000';
import { CTRL_2001 } from '../../validators/newRG/2001/ctrl2001';
import { CTRL_2002 } from '../../validators/newRG/2002/ctrl2002';
import { CTRL_2003 } from '../../validators/newRG/2003/ctrl2003';
import { StepperBuilderService } from '../../../avisDePub/creer/services/stepper.builder.service';
import { AvisDataTransferService } from '../../../shared/services/avis-data-transfer.service';
import { AnnouncerApiService } from '../../services/announcer.api.service';
import { CanNavigateInStepperService } from '../../../shared/services/can-navigate-in-stepper.service';
import { ENoticeTypeXsd } from '../../../../models/enums/enotice-type-xsd.enum';
import { EformDuplicableEntityService } from '../../eforms/services/eform-duplicable-entity.service';
import { DuplicableElementPartialPathsEnum } from '../../eforms/enum/duplicable-element-partial-paths.enum';
import { EformDataService } from '../../eforms/services/eform-data.service';
import { EformsSubjectService } from '../../eforms/services/eforms-subject.service';
import { CTRL_CHIPS } from '../../validators/newRG/CHIPS/ctrlCHIPS';
import { AccessibleToastComponent } from '../../../../components/toast/accessible-toast.component';
import { CTRL_431 } from '../../validators/431/ctrl431';
import {EformFlatFieldsService} from '../../eforms/services/eform-flat-fields.service';
import {EformChangeSectionService} from '../../eforms/services/eform-change-section.service';


@Injectable({
  providedIn: 'root'
})
export class AvisExtractorService {


  public _backErrorsBs: BehaviorSubject<any> = new BehaviorSubject([]);
  public toasterMessage = new ToasterMessage();
  public referenceAvis !: String;
  public isFirstLoad = true;
  private LOG: LogService = new LogService(AvisExtractorService);
  // ✅ FIX 2026-01-08: Stocker la souscription pour éviter les appels multiples
  private isValidObsSubscription: Subscription = null;

  constructor(private formExtractorService: FormExtractorService,
              private formulaireServiceService: FormulaireServiceService,
              private errorWafConverterService: ErrorWafConverterService,
              private facturationApiService: FacturationApiService,
              private idWebApiService: IdWebApiService,
              private announcerApiService: AnnouncerApiService,
              private toastr: ToastrService,
              private translateService: TranslateService,
              private router: Router,
              private autoCompleteService: AutoCompleteService,
              private stepperBuilderService: StepperBuilderService,
              private avisDataTransferService: AvisDataTransferService,
              private canNavigateInStepperService: CanNavigateInStepperService,
              private eformDuplicableEntityService: EformDuplicableEntityService,
              private eformDataService: EformDataService,
              private eformsSubjectService: EformsSubjectService,
              private eformConditionsV2Service: EformConditionsV2Service,
              private eformFlatFieldsService: EformFlatFieldsService,
              private eformChangeSectionService: EformChangeSectionService
  ) {
  }

  public validate(form, stepId, exportXML, facturationIndex, onFinish: () => void) {
    const ctrlMap = this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);

    // vérifier si tous les contrôles sont existants
    for (const rg of CTRL_NAME_EXTRACTOR.getCtrlNames(form, 'CTRL_')) {
      if (form?.controls[rg]?.value?.rgCtrls != null || form?.controls[rg]?.value?.rgCtrls != undefined) {
        Object.entries<string>(form.controls[rg].value.rgCtrls).forEach(inputName => {
          if (!ctrlMap.has(inputName[1])) {
            if (inputName[1] && inputName[1].includes('_index_INDEX_')) {
              this.LOG.debug(' input to fix : ', inputName[1], rg, form.controls[rg].value, ctrlMap);
            } else {
              this.LOG.debug(' input undefined : ', inputName[1], rg, form.controls[rg].value, ctrlMap);
            }
          }
        });
      }
    }
    // -----
    const ctrl417: CTRL_417 = new CTRL_417();
    ctrl417.validate(form, ctrlMap);
    // ---
    const ctrl797: CTRL_797 = new CTRL_797();
    ctrl797.validate(form, ctrlMap);
    const ctrl467: CTRL_467 = new CTRL_467();
    ctrl467.validate(form, ctrlMap);
    const ctrl468: CTRL_468 = new CTRL_468();
    ctrl468.validate(form, ctrlMap);
    const ctrl496: CTRL_496 = new CTRL_496();
    ctrl496.validate(form, ctrlMap);
    const ctrl474: CTRL_474 = new CTRL_474();
    ctrl474.validate(form, ctrlMap);
    const ctrl494: CTRL_494 = new CTRL_494();
    ctrl494.validate(form, ctrlMap);
    const ctrl495: CTRL_495 = new CTRL_495();
    ctrl495.validate(form, ctrlMap);
    const ctrl1101: CTRL_1101 = new CTRL_1101();
    ctrl1101.validate(form, ctrlMap);
    const ctrl19: CTRL_19 = new CTRL_19();
    ctrl19.validate(form, ctrlMap);
    const ctrl805: CTRL_805 = new CTRL_805();
    ctrl805.validate(form, ctrlMap);
    const ctrl24: CTRL_24 = new CTRL_24();
    ctrl24.validate(form, ctrlMap);
    const ctrl274: CTRL_274 = new CTRL_274();
    ctrl274.validate(form, ctrlMap);
    const ctrl16: CTRL_16 = new CTRL_16();
    ctrl16.validate(form, ctrlMap);
    const ctrl1216: CTRL_1216 = new CTRL_1216();
    ctrl1216.validate(form, ctrlMap);
    const ctrl1222: CTRL_1222 = new CTRL_1222();
    ctrl1222.validate(form, ctrlMap);
    const ctrl500: CTRL_500 = new CTRL_500();
    ctrl500.validate(form, ctrlMap);
    const ctrl500u2: CTRL_500u2 = new CTRL_500u2();
    ctrl500u2.validate(form, ctrlMap);
    const ctrl499: CTRL_499 = new CTRL_499();
    ctrl499.validate(form, ctrlMap);
    const ctrl18: CTRL_18 = new CTRL_18();
    ctrl18.validate(form, ctrlMap);
    const ctrl870: CTRL_870 = new CTRL_870();
    ctrl870.validate(form, ctrlMap);
    const ctrl760: CTRL_760 = new CTRL_760();
    ctrl760.validate(form, ctrlMap);
    const ctrl471: CTRL_471 = new CTRL_471();
    ctrl471.validate(form, ctrlMap);
    const ctrl473: CTRL_473 = new CTRL_473();
    ctrl473.validate(form, ctrlMap);
    const ctrl1198: CTRL_1198 = new CTRL_1198();
    ctrl1198.validate(form, ctrlMap);
    // TODO : FIX  : ça pose pb pour le MAPA_IN
    const ctrl237: CTRL_237 = new CTRL_237();
    ctrl237.validate(form, ctrlMap);
    const ctrl522: CTRL_522 = new CTRL_522();
    ctrl522.validate(form, ctrlMap);
    const ctrl637: CTRL_637 = new CTRL_637();
    ctrl637.validate(form, ctrlMap);
    const ctrl1028: CTRL_1028 = new CTRL_1028();
    ctrl1028.validate(form, ctrlMap);
    const ctrl503: CTRL_503 = new CTRL_503();
    ctrl503.validate(form, ctrlMap);
    const ctrl1164: CTRL_1164 = new CTRL_1164();
    ctrl1164.validate(form, ctrlMap);
    const ctrl966: CTRL_966 = new CTRL_966();
    ctrl966.validate(form, ctrlMap);
    const ctrl651: CTRL_651 = new CTRL_651();
    ctrl651.validate(form, ctrlMap);
    const ctrl1106: CTRL_1106 = new CTRL_1106();
    ctrl1106.validate(form, ctrlMap);
    const ctrl778: CTRL_778 = new CTRL_778();
    ctrl778.validate(form, ctrlMap);
    const ctrl1103: CTRL_1103 = new CTRL_1103();
    ctrl1103.validate(form, ctrlMap);
    const ctrl772: CTRL_772 = new CTRL_772();
    ctrl772.validate(form, ctrlMap);
    const ctrl1204: CTRL_1204 = new CTRL_1204();
    ctrl1204.validate(form, ctrlMap);
    const ctrl1206: CTRL_1206 = new CTRL_1206();
    ctrl1206.validate(form, ctrlMap);
    const ctrl812: CTRL_812 = new CTRL_812();
    ctrl812.validate(form, ctrlMap);
    const ctrl1169: CTRL_1169 = new CTRL_1169();
    ctrl1169.validate(form, ctrlMap);
    const ctrl445: CTRL_445 = new CTRL_445();
    ctrl445.validate(form, ctrlMap);
    const ctrl28_1: CTRL_28_1 = new CTRL_28_1();
    ctrl28_1.validate(form, ctrlMap);
    const ctrl28_2: CTRL_28_2 = new CTRL_28_2();
    ctrl28_2.validate(form, ctrlMap);
    const ctrl28_3: CTRL_28_3 = new CTRL_28_3();
    ctrl28_3.validate(form, ctrlMap);
    const ctrl774: CTRL_774 = new CTRL_774();
    ctrl774.validate(form, ctrlMap);
    const ctrl442: CTRL_442 = new CTRL_442();
    ctrl442.validate(form, ctrlMap);
    const ctrl517: CTRL_517 = new CTRL_517();
    ctrl517.validate(form, ctrlMap);
    const ctrl525: CTRL_525 = new CTRL_525();
    ctrl525.validate(form, ctrlMap);
    const ctrl525u2: CTRL_525u2 = new CTRL_525u2();
    ctrl525u2.validate(form, ctrlMap);
    const ctrl1019: CTRL_1019 = new CTRL_1019();
    ctrl1019.validate(form, ctrlMap);
    const ctrl795: CTRL_795 = new CTRL_795();
    ctrl795.validate(form, ctrlMap);
    const ctrl1108: CTRL_1108 = new CTRL_1108();
    ctrl1108.validate(form, ctrlMap);
    const ctrl403: CTRL_403 = new CTRL_403();
    ctrl403.validate(form, ctrlMap);
    const ctrl626_def: CTRL_626_def = new CTRL_626_def();
    ctrl626_def.validate(form, ctrlMap);
    const ctrl629: CTRL_629 = new CTRL_629();
    ctrl629.validate(form, ctrlMap);
    const ctrl630: CTRL_630 = new CTRL_630();
    ctrl630.validate(form, ctrlMap);
    const ctrl672: CTRL_672 = new CTRL_672();
    ctrl672.validate(form, ctrlMap);
    const ctrl664: CTRL_664 = new CTRL_664();
    ctrl664.validate(form, ctrlMap);
    const ctrl1020: CTRL_1020 = new CTRL_1020();
    ctrl1020.validate(form, ctrlMap);
    const ctrl202: CTRL_202 = new CTRL_202();
    ctrl202.validate(form, ctrlMap);
    const ctrl203: CTRL_203 = new CTRL_203();
    ctrl203.validate(form, ctrlMap);
    const ctrl204: CTRL_204 = new CTRL_204();
    ctrl204.validate(form, ctrlMap);
    const ctrl205: CTRL_205 = new CTRL_205();
    ctrl205.validate(form, ctrlMap);
    const ctrl526: CTRL_526 = new CTRL_526();
    ctrl526.validate(form, ctrlMap);
    const ctrl526u2: CTRL_526u2 = new CTRL_526u2();
    ctrl526u2.validate(form, ctrlMap);
    const ctrl527: CTRL_527 = new CTRL_527();
    ctrl527.validate(form, ctrlMap);
    const ctrl528: CTRL_528 = new CTRL_528();
    ctrl528.validate(form, ctrlMap);
    const ctrl529: CTRL_529 = new CTRL_529();
    ctrl529.validate(form, ctrlMap);
    const ctrl742: CTRL_742 = new CTRL_742();
    ctrl742.validate(form, ctrlMap);
    const ctrl746: CTRL_746 = new CTRL_746();
    ctrl746.validate(form, ctrlMap);
    const ctrl806: CTRL_806 = new CTRL_806();
    ctrl806.validate(form, ctrlMap);
    const ctrl1111: CTRL_1111 = new CTRL_1111();
    ctrl1111.validate(form, ctrlMap);
    const ctrl1112: CTRL_1112 = new CTRL_1112();
    ctrl1112.validate(form, ctrlMap);
    const ctrl1200: CTRL_1200 = new CTRL_1200();
    ctrl1200.validate(form, ctrlMap);
    const ctrl524: CTRL_524 = new CTRL_524();
    ctrl524.validate(form, ctrlMap);

    const ctrl1002: CTRL_1002 = new CTRL_1002();
    ctrl1002.validate(form, ctrlMap);
    const ctrl107: CTRL_107 = new CTRL_107();
    ctrl107.validate(form, ctrlMap);
    const ctrl1162: CTRL_1162 = new CTRL_1162();
    ctrl1162.validate(form, ctrlMap);
    const ctrl1203: CTRL_1203 = new CTRL_1203();
    ctrl1203.validate(form, ctrlMap);
    const ctrl1211: CTRL_1211 = new CTRL_1211();
    ctrl1211.validate(form, ctrlMap);
    const ctrl123: CTRL_123 = new CTRL_123();
    ctrl123.validate(form, ctrlMap);
    const ctrl14: CTRL_14 = new CTRL_14();
    ctrl14.validate(form, ctrlMap);
    const ctrl15: CTRL_15 = new CTRL_15();
    ctrl15.validate(form, ctrlMap);
    const ctrl175: CTRL_175 = new CTRL_175();
    ctrl175.validate(form, ctrlMap);
    const ctrl176: CTRL_176 = new CTRL_176();
    ctrl176.validate(form, ctrlMap);
    const ctrl20: CTRL_20 = new CTRL_20();
    ctrl20.validate(form, ctrlMap);
    const ctrl221: CTRL_221 = new CTRL_221();
    ctrl221.validate(form, ctrlMap);
    const ctrl263: CTRL_263 = new CTRL_263();
    ctrl263.validate(form, ctrlMap);
    const ctrl29: CTRL_29 = new CTRL_29();
    ctrl29.validate(form, ctrlMap);
    const ctrl31: CTRL_31 = new CTRL_31();
    ctrl31.validate(form, ctrlMap);
    const ctrl33: CTRL_33 = new CTRL_33();
    ctrl33.validate(form, ctrlMap);
    const ctrl34: CTRL_34 = new CTRL_34();
    ctrl34.validate(form, ctrlMap);
    const ctrl36: CTRL_36 = new CTRL_36();
    ctrl36.validate(form, ctrlMap);
    const ctrl38: CTRL_38 = new CTRL_38();
    ctrl31.validate(form, ctrlMap);
    const ctrl40: CTRL_40 = new CTRL_40();
    ctrl40.validate(form, ctrlMap);
    const ctrl406: CTRL_406 = new CTRL_406();
    ctrl406.validate(form, ctrlMap);
    const ctrl410: CTRL_410 = new CTRL_410();
    ctrl410.validate(form, ctrlMap);
    const ctrl411_def: CTRL_411_def = new CTRL_411_def();
    ctrl411_def.validate(form, ctrlMap);
    const ctrl418: CTRL_418 = new CTRL_418();
    ctrl418.validate(form, ctrlMap);
    const ctrl419: CTRL_419 = new CTRL_419();
    ctrl419.validate(form, ctrlMap);
    const ctrl43: CTRL_43 = new CTRL_43();
    ctrl43.validate(form, ctrlMap);
    const ctrl430: CTRL_430 = new CTRL_430();
    ctrl430.validate(form, ctrlMap);
    const ctrl431: CTRL_431 = new CTRL_431();
    ctrl431.validate(form, ctrlMap);
    const ctrl432: CTRL_432 = new CTRL_432();
    ctrl432.validate(form, ctrlMap);
    const ctrl444: CTRL_444 = new CTRL_444();
    ctrl444.validate(form, ctrlMap);
    const ctrl48: CTRL_48 = new CTRL_48();
    ctrl48.validate(form, ctrlMap);
    const ctrl49: CTRL_49 = new CTRL_49();
    ctrl49.validate(form, ctrlMap);
    const ctrl57: CTRL_57 = new CTRL_57();
    ctrl57.validate(form, ctrlMap);
    const ctrl65: CTRL_65 = new CTRL_65();
    ctrl65.validate(form, ctrlMap);
    const ctrl69: CTRL_69 = new CTRL_69();
    ctrl69.validate(form, ctrlMap);
    const ctrl11: CTRL_11 = new CTRL_11();
    ctrl11.validate(form, ctrlMap);
    const ctrl72: CTRL_72 = new CTRL_72();
    ctrl72.validate(form, ctrlMap);
    const ctrl73: CTRL_73 = new CTRL_73();
    ctrl73.validate(form, ctrlMap);
    const ctrl416: CTRL_416 = new CTRL_416();
    ctrl416.validate(form, ctrlMap);
    const ctrl754: CTRL_754 = new CTRL_754();
    ctrl754.validate(form, ctrlMap);
    const ctrl813: CTRL_813 = new CTRL_813();
    ctrl813.validate(form, ctrlMap);
    const ctrl77: CTRL_77 = new CTRL_77();
    ctrl77.validate(form, ctrlMap);
    const ctrl8: CTRL_8 = new CTRL_8();
    ctrl8.validate(form, ctrlMap);
    const ctrl9: CTRL_9 = new CTRL_9();
    ctrl9.validate(form, ctrlMap);


    const ctrl626_horsDef: CTRL_626_horsDef = new CTRL_626_horsDef();
    ctrl626_horsDef.validate(form, ctrlMap);
    const ctrl621_horsDef: CTRL_621_horsDef = new CTRL_621_horsDef();
    ctrl621_horsDef.validate(form, ctrlMap);
    const ctrl621: CTRL_621 = new CTRL_621();
    ctrl621.validate(form, ctrlMap);
    const ctrl625: CTRL_625 = new CTRL_625();
    ctrl625.validate(form, ctrlMap);
    const ctrl120: CTRL_120 = new CTRL_120();
    ctrl120.validate(form, ctrlMap);
    const ctrl380: CTRL_380 = new CTRL_380();
    ctrl380.validate(form, ctrlMap);
    const ctrl103: CTRL_103 = new CTRL_103();
    ctrl103.validate(form, ctrlMap);
    const ctrl286: CTRL_286 = new CTRL_286();
    ctrl286.validate(form, ctrlMap);
    const ctrl290: CTRL_290 = new CTRL_290();
    ctrl290.validate(form, ctrlMap);
    const ctrl292: CTRL_292 = new CTRL_292();
    ctrl292.validate(form, ctrlMap);
    const ctrl215: CTRL_215 = new CTRL_215();
    ctrl215.validate(form, ctrlMap);
    const ctrl411_horsDef: CTRL_411_horsDef = new CTRL_411_horsDef();
    ctrl411_horsDef.validate(form, ctrlMap);
    const ctrl1027: CTRL_1027 = new CTRL_1027();
    ctrl1027.validate(form, ctrlMap);
    const ctrl299: CTRL_299 = new CTRL_299();
    ctrl299.validate(form, ctrlMap);
    const ctrl1025: CTRL_1025 = new CTRL_1025();
    ctrl1025.validate(form, ctrlMap);
    const ctrl1024: CTRL_1024 = new CTRL_1024();
    ctrl1024.validate(form, ctrlMap);
    const ctrl21: CTRL_21 = new CTRL_21();
    ctrl21.validate(form, ctrlMap);
    const ctrl439: CTRL_439 = new CTRL_439();
    ctrl439.validate(form, ctrlMap);
    const ctrl438: CTRL_438 = new CTRL_438();
    ctrl438.validate(form, ctrlMap);
    const ctrl446: CTRL_446 = new CTRL_446();
    ctrl446.validate(form, ctrlMap);
    const ctrl331: CTRL_331 = new CTRL_331();
    ctrl331.validate(form, ctrlMap);
    const ctrl334: CTRL_334 = new CTRL_334();
    ctrl334.validate(form, ctrlMap);
    const ctrl322: CTRL_322 = new CTRL_322();
    ctrl322.validate(form, ctrlMap);
    const ctrl426: CTRL_426 = new CTRL_426();
    ctrl426.validate(form, ctrlMap);
    const ctrl427: CTRL_427 = new CTRL_427();
    ctrl427.validate(form, ctrlMap);
    const ctrl429: CTRL_429 = new CTRL_429();
    ctrl429.validate(form, ctrlMap);
    const ctrl740: CTRL_740 = new CTRL_740();
    ctrl740.validate(form, ctrlMap);
    const ctrlMONEY: CTRL_MONEY = new CTRL_MONEY();
    ctrlMONEY.validate(form, ctrlMap);
    const ctrlADR: CTRL_ADR = new CTRL_ADR();
    ctrlADR.validate(form, ctrlMap);
    const ctrl252: CTRL_252 = new CTRL_252();
    ctrl252.validate(form, ctrlMap, this.autoCompleteService);
    const ctrl9201: CTRL_9201 = new CTRL_9201();
    ctrl9201.validate(form, ctrlMap);
    const ctrl469: CTRL_469 = new CTRL_469();
    ctrl469.validate(form, ctrlMap);
    const ctrl1120: CTRL_1120 = new CTRL_1120();
    ctrl1120.validate(form, ctrlMap);
    const ctrl1086: CTRL_1086 = new CTRL_1086();
    ctrl1086.validate(form, ctrlMap);
    const ctrl1087: CTRL_1087 = new CTRL_1087();
    ctrl1087.validate(form, ctrlMap);
    const ctrlDate: CTRL_DATE = new CTRL_DATE();
    ctrlDate.validate(form, ctrlMap);
    const ctrl654: CTRL_654 = new CTRL_654();
    ctrl654.validate(form, ctrlMap);
    const ctrl270: CTRL_270 = new CTRL_270();
    ctrl270.validate(form, ctrlMap);
    const ctrl416HorsDef: CTRL_416HorsDef = new CTRL_416HorsDef();
    ctrl416HorsDef.validate(form, ctrlMap);
    const ctrlTrim: CTRL_TRIM = new CTRL_TRIM();
    ctrlTrim.validate(form, ctrlMap);
    const ctrl268: CTRL_268 = new CTRL_268();
    ctrl268.validate(form, ctrlMap);

    this.facturationApiService.validate(form, this.referenceAvis).subscribe(
      (response) => {
        if (response?.status === 'KO') {
          this._backErrorsBs.next(response.erreursBloquantes || []);
        } else {
          this._backErrorsBs.next([]);
        }
      },
      (error) => {
        this._backErrorsBs.next([]);
      }
    );
    const ctrl2000: CTRL_2000 = new CTRL_2000();
    ctrl2000.validate(form, ctrlMap);
    const ctrl2001: CTRL_2001 = new CTRL_2001();
    ctrl2001.validate(form, ctrlMap);
    const ctrl2002: CTRL_2002 = new CTRL_2002();
    ctrl2002.validate(form, ctrlMap);
    const ctrl2003: CTRL_2003 = new CTRL_2003();
    ctrl2003.validate(form, ctrlMap);
    const ctrlCHIPS: CTRL_CHIPS = new CTRL_CHIPS();
    ctrlCHIPS.validate(form, ctrlMap);
    this.idWebApiService.validate(form, stepId);
    this.announcerApiService.validate(form);
    this.formulaireServiceService.isFormValid(form, stepId, exportXML, onFinish);

    // Fix PRB0051265 (à supprimer après passage au sdk 1.14)
    // À supprimer lors du passage au SDK 1.14
    const flatFields  = this.eformFlatFieldsService.flatFieldsValue;
    const prizeValues = flatFields.has('BT-644-Lot') ? flatFields.get('BT-644-Lot') : [];
    const prizeRanks  = flatFields.has('BT-44-Lot') ? flatFields.get('BT-44-Lot') : [];
    const cleanPath = path => {
      return `eforms${path.replace('jsonsaisieformulaire.ann', '').replace(/procurementprojectlot.\d*/, 'procurementprojectlot.0')}.val`;
    };

    prizeValues.forEach(pvField => {
      const pvKey = cleanPath(pvField.path);
      if (!pvKey || !form.get(pvKey)?.value) {
        // BT-644-Lot absent ou vide
        return;
      }

      // Trouver le BT-44-Lot du même lot (même duplicableIndex)
      const pvIndexes = /.*\.(\d+)\..*\.(\d+)\.*./.exec(pvField.path);

      if (!pvIndexes?.length) {
        return;
      }

      const rankField = prizeRanks.find(f => {
        const rankIndexes = /.*\.(\d+)\..*\.(\d+)\.*./.exec(f.path);

        if (!rankIndexes?.length) {
          return false;
        }

        return rankIndexes[1] === pvIndexes[1] && rankIndexes[2] === pvIndexes[2];
      });
      if (!rankField) {
        return;
      }

      const rankKey = cleanPath(rankField.path);
      if (!form.get(rankKey)?.value) {
        // BT-44-Lot vide
        const lotIndex = rankField.duplicableIndex ?? 0;
        this.stepperBuilderService.addStepFieldsOnErrors(`GR-Lot_${lotIndex}_1`,
          `GR-Lot_${lotIndex}_1|BT-44-Lot_0_${pvIndexes[2]}`,
          `Lieu de réception de la prime - 'Lieu de réception de la prime' (BT-44-Lot) est obligatoire si le 'Valeur de la prime' (BT-644-Lot) est renseigné.`);
      }
    });
    // Fin fix PRB0051265 (à supprimer après passage au sdk 1.14)

    // PRB0054349 : au moins une section modifiée (BT-13716-notice) sur un avis rectificatif eForms
    this.eformChangeSectionService.validate(form);
  }

  public saveForm(form, avisId, referenceAvis, critereId, onModification, flux, stepId, actualPageIndex, stepValue = null, referenceAvisParent = null, refAvisLie = null): Observable<Avis> {
    // 🔧 FIX Firefox 2026-05-04 : En Chrome, le composant Angular rend le lot dans le FormGroup
    // AVANT le premier CREATE, donc form.getRawValue() contient un lot avec id.inputId.
    // En Firefox, le CREATE se déclenche parfois avant ce rendu → le lot Angular manque → le
    // backend stocke les lots sans tenderingterms complet → schematron retourne ND-LotTenderingTerms.
    // Solution : si c'est un CREATE eForms et que le lot Angular n'est pas encore dans le form,
    // on attend (max ~1500ms, toutes les 100ms) qu'il apparaisse avant d'extraire et d'envoyer.
    const _firstItemNameForCheck = ENoticeTypeXsd[this.stepperBuilderService.formulaire];
    if (!onModification && _firstItemNameForCheck && form) {
      const _hasFormLot = (): boolean => {
        try {
          const lots = form.getRawValue()?.eforms?.[_firstItemNameForCheck.toLowerCase()]?.procurementprojectlot;
          return Array.isArray(lots) && lots.some((l: any) => l?.id?.inputId);
        } catch { return false; }
      };
      if (!_hasFormLot()) {
        return new Observable<Avis>(observer => {
          let _attempts = 0;
          const _poll = setInterval(() => {
            _attempts++;
            if (_hasFormLot() || _attempts >= 15) {
              clearInterval(_poll);
              this._executeSaveForm(form, avisId, referenceAvis, critereId, onModification, flux, stepId, actualPageIndex, stepValue, referenceAvisParent, refAvisLie)
                .subscribe({ next: v => observer.next(v), error: e => observer.error(e), complete: () => observer.complete() });
            }
          }, 100);
          return () => clearInterval(_poll);
        });
      }
    }
    return this._executeSaveForm(form, avisId, referenceAvis, critereId, onModification, flux, stepId, actualPageIndex, stepValue, referenceAvisParent, refAvisLie);
  }

  private _executeSaveForm(form, avisId, referenceAvis, critereId, onModification, flux, stepId, actualPageIndex, stepValue = null, referenceAvisParent = null, refAvisLie = null): Observable<Avis> {
  this.errorWafConverterService.sanitize(form);
  this.errorWafConverterService.convertErrorWaf(form);
    let avis = this.formulaireServiceService.extractAvis(form, avisId, referenceAvis, critereId, stepId, actualPageIndex, flux, stepValue, onModification, refAvisLie);


  if (this.avisDataTransferService.contenuPdf == undefined) {
    this.avisDataTransferService.contenuPdf = new ContenuPdf();
  }
  if (actualPageIndex >= 1) {
    this.preparePdf(form, this.avisDataTransferService.contenuPdf, actualPageIndex);
  }
  this.setPdfIntoAvis(avis, this.avisDataTransferService.contenuPdf);
  if (actualPageIndex >= 1) {
    this.prepareJsonCSV(form, actualPageIndex, this.avisDataTransferService.contenuPdf);
  }
  if (this.avisDataTransferService.sourceAppProfilAcheteurInfos) {
    avis.jsonSaisieFormulaire.sourceAppProfilAcheteurInfos = this.avisDataTransferService.sourceAppProfilAcheteurInfos;
  } else {
    avis.refConsultation = sessionStorage.getItem('referenceConsultation');
  }
  avis.jsonFieldsErrorsWarnings = this.stepperBuilderService.prepareJsonErrors();
  avis.jsonCSV = this.avisDataTransferService.jsonCSV;


  this.avisDataTransferService.setFormData(avis);
  this.errorWafConverterService.deconvertErrorWaf(form);
  return this.updateOrCreate(avis, referenceAvisParent, onModification, form);
}

  public clearSessionStorageDuplicableElement() {
    if (this.hasDuplicableObjectInSessionStorage()) {
      Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
        sessionStorage.removeItem(key);
      });
    }
  }

  public sendForm(form, avisId, referenceAvis, critereId, flux, facturationIndex, isBOAMPorJOUE, ann, onFinish: () => void ): Observable<any> {
    let isSent = new EventEmitter<boolean>();

    if (this._backErrorsBs.value.length > 0) {
      onFinish();
      return EMPTY;
    }

    // ✅ FIX: Flag pour empêcher les doubles appels à /avis/verif
    let verifAlreadyCalled = false;

    this.canNavigateInStepperService.verifyAnnonceur(form, isBOAMPorJOUE).pipe(
      first(),
      switchMap((isVerify) =>
    {
      if(!isVerify) {
        this.canNavigateInStepperService.openModal(this.canNavigateInStepperService.compatibiliteMessage.M026);
        return of(false);
      }

      const codeAvis = this.stepperBuilderService?.formulaire?.toString();

      if (codeAvis?.includes('E_FORM')) {
        return this.canNavigateInStepperService.verifyAnnonceurAvisLie(form, referenceAvis).pipe(
          first(),
          tap((isMemeAnnonceur) => {
            if (!isMemeAnnonceur) {
              this.canNavigateInStepperService.openModal(this.canNavigateInStepperService.compatibiliteMessage.M043);
            }
          })
        );
      }

      const avisNecessitantUneVerif = [
        'DIVE_AN', 'DIVE_AT', 'DIVE_RE',
        'MAPA_AN', 'MAPA_AT', 'MAPA_RE',
        'SIMP_AN', 'SIMP_AT', 'SIMP_RE'
      ];

      if(!avisNecessitantUneVerif.includes(codeAvis)) {
        return of(true);
      }

      return this.idWebApiService.verifyIdWeb(form, codeAvis, ann).pipe(
        first(),
        tap((isVerifyIdWeb) => {
          if(!isVerifyIdWeb) {
            this.canNavigateInStepperService.openModal(this.canNavigateInStepperService.compatibiliteMessage.M043);
          }
        }),
        filter(Boolean)
      );
    }), filter(Boolean),
    finalize(() => {
      onFinish();
    })
  ).subscribe(() => {
    form.controls.submitted.setValue(true);
        this.referenceAvis = referenceAvis;
        if (this.canNavigateInStepperService.isCreerAvisLierSelected) {
          this.stepperBuilderService.clearStepFieldsOnErrors('_STEP_ID_1');
        }
        // ✅ FIX: Réinitialiser isValidObs à false avant la validation pour éviter
        // que l'ancienne valeur true ne déclenche immédiatement le subscribe
        this.formulaireServiceService.isValidObs.next(false);

        // ✅ FIX 2026-01-08: Désabonner l'ancienne souscription pour éviter les appels multiples
        if (this.isValidObsSubscription) {
          this.isValidObsSubscription.unsubscribe();
          this.isValidObsSubscription = null;
        }

        this.validateForm(form, referenceAvis, 0, true, facturationIndex, onFinish);
        this.stepperBuilderService.stepFieldsOnErrors.forEach(stepError => {
          stepError.isCheckValid = true;
        });
        this.isValidObsSubscription = this.formulaireServiceService.isValidObs.pipe(first(e => e === true)).subscribe((isValid) => {
          // ✅ FIX: Empêcher le double appel à /avis/verif
          if (verifAlreadyCalled) {
            return;
          }
          if (isValid && this.stepperBuilderService.haventFormErrors()) {
            verifAlreadyCalled = true;
            // PRB0052504 : plus de remise à blanc ('' / null) des critères sociaux et environnementaux
            // avant l'extraction. Le chemin national poste désormais 'Oui' / 'Non' comme le chemin
            // eForms ; c'est le back qui normalise (cf. MR avis-de-publication !970). La remise à
            // blanc réintroduirait ici un '' que IndexationService.getIndexation relirait comme
            // « non renseigné » et forcerait à 'Non'.
            this.errorWafConverterService.convertErrorWaf(form);
            const refAvisLie = this.canNavigateInStepperService.getReferenceParent()?.reference;
            let avis = this.formulaireServiceService.extractAvis(form, avisId, referenceAvis, critereId, 2, undefined, flux, null, true, refAvisLie ?? null);
            avis = this.updateBooleanValueFromAvis(avis);
            avis.jsonFieldsErrorsWarnings = this.stepperBuilderService.prepareJsonErrors();
            avis.jsonCSV = this.avisDataTransferService.jsonCSV;
            this.avisDataTransferService.setFormData(avis);
            this.errorWafConverterService.deconvertErrorWaf(form);
            let contenuPdf = new ContenuPdf();
            contenuPdf = this.avisDataTransferService.contenuPdf;
            // ✅ FIX: Passer undefined au lieu de 2 pour ne pas réinitialiser _STEP_ID_2
            // (Section 2 Communication) lors de l'envoi. Le "2" était interprété comme
            // _STEP_ID_2 dans getJSON, ce qui écrasait les champs déjà collectés pendant
            // la navigation dans le stepper. Avec undefined, aucun step n'est réinitialisé
            // et les données de facturation/indexation sont toujours extraites correctement.
            contenuPdf.champs = this.formulaireServiceService.getJSON(form, undefined, contenuPdf).formulaire;
            contenuPdf.formulaireAdapte = this.formulaireServiceService.formulaireAdapte;
            contenuPdf.typeAvis = FormsMapper.getIntitule(avis.formulaire.code)?.toString().includes('eform') ? this.translateService.instant(FormsMapper.getIntitule(avis.formulaire.code)) : FormsMapper.getIntitule(avis.formulaire.code);
            avis.jsonPdf = contenuPdf;
            // traiter la validation coté back
            this.formulaireServiceService.validate(avis).pipe(map((data) => {
                this._backErrorsBs.next(data.errors);
                if (data.errors.length > 0) {
                  this.toastr.show(
                    this.translateService.instant(this.toasterMessage.sendFailXSD || 'toast.sendFailXSD'),
                    this.translateService.instant(this.toasterMessage.errorTitle || 'toast.errorTitle'),
                    {
                      positionClass: 'toast-top-right',
                      toastComponent: AccessibleToastComponent
                    },
                    'error'
                  );
                } else {
                  this.toastr.show(this.translateService.instant(this.toasterMessage.sendSuccess || 'toast.sendSuccess'),
                    this.translateService.instant(this.toasterMessage.sendSuccessTitle || 'toast.sendSuccessTitle'), {
                      positionClass: 'toast-top-right',
                      toastComponent: AccessibleToastComponent
                    },
                    'info'
                  );
                }
                this.router.navigate(['/avisdepublicite/listerAvisPub/']);
                onFinish();
                isSent.emit(data);
                isSent.complete();
              },
              (error) => {
                this.toastr.show(this.translateService.instant(this.toasterMessage.error || 'toast.error'),
                  this.translateService.instant(this.toasterMessage.errorTitle || 'toast.errorTitle'), {
                    positionClass: 'toast-top-right',
                    toastComponent: AccessibleToastComponent
                  },
                  'error');
                  onFinish();
                isSent.error(error.message);
                throw new Error(error.message);
              }
            )).subscribe();
          } else {
            onFinish();
            isSent.emit(null);
            isSent.complete();
          }
        });
  });
    return isSent.asObservable();
  }

  public validateForm(form, referenceAvis: any, stepId, exportXML, facturationIndex, onFinish: () => void) {
    form.controls.submitted.setValue(true);
    this.referenceAvis = referenceAvis;
    this.errorWafConverterService.sanitize(form);
    this.validate(form, stepId, exportXML, facturationIndex, onFinish);
  }

  public getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form) {
    return this.formExtractorService.getMap_ControlsID_ControlsIDWithoutStepIdCommonId(form);
  }

private preparePdf(form, contenuPdf, stepId) {
  const json = this.formulaireServiceService.getJSON(form, stepId, contenuPdf);

  // Synchroniser les valeurs du formulaire avec le JSON
  const formControls = form?.controls || {};
  const formulaire = json?.formulaire || {};
  Object.entries(formControls)
    .filter(([name]) => name.endsWith('_SepAtt_urlProfilAch_radio'))
    .forEach(([radioName, radioCtrl]: [string, any]) => {
      const selectedValue: string = radioCtrl?.value;

      // Préfix commun avant "urlProfilAch_radio"
      const prefix = radioName.replace('_SepAtt_urlProfilAch_radio', '_SepAtt_');

      const candidateXPaths = [
        prefix + 'urlProfilAch',
        prefix + 'urlDocConsul',
        prefix + 'autre'
      ];

      const activeXpath = selectedValue ? prefix + selectedValue : null;

      candidateXPaths.forEach(xpath => {
        Object.keys(formulaire || {}).forEach(sectionKey => {
          const sectionFields = formulaire[sectionKey] || [];
          sectionFields.forEach(field => {
            if (field && field.xpath === xpath) {
              // Si ce n'est pas le champ correspondant au radio sélectionné, on le vide
              if (!activeXpath || xpath !== activeXpath) {
                field.value = '';
              }
            }
          });
        });
      });
    });

  for (const sectionKey of Object.keys(formulaire)) {
    const sectionFields = formulaire[sectionKey];

    sectionFields
      .filter(f => f?.xpath && f.xpath.endsWith('_SepAtt_montantIndefini'))
      .forEach(indefField => {
        const xpIndef = indefField.xpath;
        const indefCtrl = formControls[xpIndef];

        const checked =
          indefCtrl?.value === true ||
          indefField.value === true;

        if (!checked) {
          return;
        }

        const basePrefix = xpIndef.replace('_SepAtt_montantIndefini', '');

        sectionFields.forEach(f => {
          if (!f?.xpath || f === indefField) {
            return;
          }

          const xp = f.xpath;


          if (!xp.startsWith(basePrefix)) {
            return;
          }


          const isTypeMontant =
            xp.startsWith(basePrefix + '_SepSep_TypeMontant_SepAtt_');
          const isMontantAnnuel =
            xp.startsWith(basePrefix + '_SepSep_MontantAnnuel_SepAtt_');
          const isOffres =
            xp.startsWith(basePrefix + '_SepSep_Offres_SepAtt_');
          const isTranche =
            xp === basePrefix + '_SepAtt_trancheConditionnelle' ||
            xp === basePrefix + '_SepAtt_trancheFerme';

          if (isTypeMontant || isMontantAnnuel || isOffres || isTranche) {
            f.value = undefined;
          }
        });
      });

    // Ne vider les valeurs des champs critère que lorsqu'on est sur le step qui les contient,
    // sinon les valeurs sont effacées à tort lorsque l'utilisateur navigue vers un autre step
    // (les FormControls sont détruits par *ngIf et n'existent plus dans le formulaire).
    if (sectionKey === '_STEP_ID_' + stepId) {
      sectionFields.filter(f => f?.xpath &&  (f?.type === "text" || f?.type === "chips") && f?.label && f?.label.includes("getcritere"))
      .forEach(field => {
        const controlText = formControls[field?.xpath];
            if (!controlText) {
              field.value = undefined;
            }
      });
    }

  }


  if (this.stepperBuilderService.formulaire.toString() === "MAPA_AT") {
    for (const sectionKey of Object.keys(formulaire)) {
      const sectionFields = formulaire[sectionKey];

      for (const field of sectionFields) {
        const ctrl = formControls[field.xpath];

        // Uniquement les champs texte : un radio/liste stocke un code brut dans le
        // FormControl (ex. "PriveeAssujettie"), pas le libellé extrait du DOM par getJSON().
        if (ctrl && ctrl.value !== undefined && field.type === 'text') {
          field.value = ctrl.value;
        }
        //PRB0053519: Effacer seulement les champs vides ou ctrl inexistants pour le <numero_du_step_courant>,
        // car les champs dynamiques disparaissent du DOM HTML lorsque le bloc qui les contient sont passés au niveau du stepper.
        // '_STEP_ID_' + stepId au lieu de '_STEP_ID_4' en dur
        if (sectionKey === '_STEP_ID_' + stepId && field.xpath !== undefined && field.type === 'text' &&  !ctrl) {
          field.value = undefined;
        }

      }
    }
  }

  try {
    const formControls = (form && form.controls) || {};
    Object.keys(json?.formulaire || {}).forEach(k => {
      (json.formulaire[k] || []).forEach(d => {
        if (d && d.type === 'text' && d.xpath) {
          const ctrl = formControls[d.xpath];
          if (ctrl && (ctrl.value === '' || ctrl.value === null)) {
            d.value = '';
          }
        }
      });
    });
  } catch { /* no-op */ }

  if (!form.value?.eforms) {
    Object.keys(json.formulaire).forEach(k => {
      json.formulaire[k].forEach(data => {
        // Le clone de getJSON() transforme xpath: null en clé absente (undefined) : normaliser
        // les deux côtés évite un faux négatif qui dupliquerait les legends à chaque appel.
        const dataXpath = data.xpath ?? null;
        if (contenuPdf.champs[k].filter(x => (x.xpath ?? null) === dataXpath).length > 0) {
          contenuPdf.champs[k].findLast(x => (x.xpath ?? null) === dataXpath).value = data.value;
        } else {
          contenuPdf.champs[k].push(data);
        }
      });
    });
  } else {
    contenuPdf.champs = json.formulaire;
  }

  contenuPdf.formulaireAdapte = this.formulaireServiceService.formulaireAdapte;

  if (!this.stepperBuilderService?.formulaire.toString().includes('E_FORM_')) {
    if (
      this.avisDataTransferService.siret &&
      !form.controls['_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret']?.value &&
      this.isFirstLoad
    ) {
      form.controls['_SepSep_TypeFacturation_SepSep_TypeAdresseTEMPOST_SepAtt_siret'].value =
        this.avisDataTransferService.siret;
      this.isFirstLoad = false;
    }
  }
}



  private prepareJsonCSV(form, step, contenuPdf) {
    const json = this.formulaireServiceService.getJSON(form, step, contenuPdf);
    const mapper = this.formExtractorService.getMap_ControlsIDWithoutStepIdCommonId_ControlsID(form);
    Object.keys(json.formulaire).forEach(k => {
      json.formulaire[k].forEach(data => {
        if (mapper.has(data.xpath)) {
          this.avisDataTransferService.jsonCSV[mapper.get(data.xpath)] =
            (data.type == 'checkbox' && data.value === true) ?
              this.translateService.instant(data.label) :
              (data.type == 'radio' && data.value && data.value != true) ?
                this.translateService.instant(data.value) :
                data.value;
        }
      });
    });
  }

  private setPdfIntoAvis(avis, contenuPdf) {
    if (contenuPdf) {
      contenuPdf.typeAvis = FormsMapper.getIntitule(avis.formulaire.code)?.toString().includes('eform') ? this.translateService.instant(FormsMapper.getIntitule(avis.formulaire.code)) : FormsMapper.getIntitule(avis.formulaire.code);
      avis.jsonPdf = contenuPdf;
    }
  }

  private hasDuplicableObjectInSessionStorage(): boolean {
    // Récupère toutes les valeurs de l'enum sous forme de tableau
    const enumKeys = Object.keys(DuplicableElementPartialPathsEnum);

    // Vérifie si au moins une valeur est présente dans le sessionStorage
    return enumKeys.some(value => sessionStorage.getItem(value) !== null);
  }

  private updateOrCreate(avis, referenceAvisParent, onModification, form?) {
    const lots = JSON.parse(sessionStorage.getItem('GR-Lot'));
    const firstItemName = ENoticeTypeXsd[this.stepperBuilderService.formulaire];
    const refConsultation = sessionStorage.getItem('refConsultation');
    if (refConsultation) {
      //La valeur sera affiché dans le tableau de bord
      this.avisDataTransferService.refConsultation = refConsultation;
      //La valeur sera affiché dans le champs BT-22-Part
      if (('E_FORM_4' === this.stepperBuilderService.formulaire.toString() || 'E_FORM_5' === this.stepperBuilderService.formulaire.toString() || 'E_FORM_6' === this.stepperBuilderService.formulaire.toString()) && !!lots
          && avis.jsonSaisieFormulaire.ann[firstItemName]
          && avis.jsonSaisieFormulaire.ann[firstItemName].procurementprojectlot
          && avis.jsonSaisieFormulaire.ann[firstItemName].procurementprojectlot[0]) {
        avis.jsonSaisieFormulaire.ann[firstItemName].procurementprojectlot[0].procurementproject.id.val = refConsultation;
      }
    }
    if (onModification) {
      if (lots) {
        this.eformDuplicableEntityService.needWaitEndUpdateForActiveControls = true;
      }
      //On peut supprimer les objets duplicables du session storage, tout est à jour (le form va se réinitialiser suite à cet appel)
      if (this.hasDuplicableObjectInSessionStorage() || this.canNavigateInStepperService.isCreerAvisLierSelected === true && this.canNavigateInStepperService.avisLieCreateFirstSave === true) {
        Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
          sessionStorage.removeItem(key);
        });
        this.canNavigateInStepperService.avisLieCreateFirstSave = false;
      }


      // ✅ CORRECTION FINALE 2025-12-11: Attendre que TOUS les types d'éléments duplicables
      // aient terminé leur rechargement AVANT de sauvegarder
      // IMPORTANT: Utiliser merge() pour combiner:
      // 1. allReloadingComplete - émet quand un rechargement est terminé
      // 2. Un fallback qui émet immédiatement si isReloadingDuplicableElement est déjà false
      const saveWhenAllTypesReady$ = this.eformConditionsV2Service.isReloadingDuplicableElement$.pipe(
        // Si isReloading est false, procéder immédiatement
        // Sinon, attendre que allReloadingComplete émettte
        switchMap(isReloading => {
          if (!isReloading) {
            // Pas de rechargement en cours - procéder immédiatement avec delay pour stabilité
            return of(null).pipe(delay(200));
          } else {
            // Un rechargement est en cours - attendre allReloadingComplete
            return this.eformConditionsV2Service.allReloadingComplete.pipe(
              take(1),
              switchMap(() => of(null).pipe(delay(200)))
            );
          }
        }),
        take(1),
        // Envoyer la requête de sauvegarde
        switchMap(() => this.formulaireServiceService.update(avis, referenceAvisParent))
      );

      return saveWhenAllTypesReady$.pipe(
          tap((data: any) => {
              if (this.eformDuplicableEntityService.needWaitEndUpdateForActiveControls) {
                this.eformDuplicableEntityService.avisWithElementsDuplicable.next(null);
                this.eformDuplicableEntityService.avisWithElementsDuplicable.pipe(first(d => d)).subscribe(() => {
                  this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(false);
                });
              } else {
                this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(false);
              }
              this.eformDuplicableEntityService.needWaitEndUpdateForActiveControls = false;
              this.toastr.show(this.translateService.instant(this.toasterMessage.saveSuccess || 'toast.saveSuccess'),
                this.translateService.instant(this.toasterMessage.saveSuccessTitle || 'toast.saveSuccessTitle'), {
                  positionClass: 'toast-top-right',
                  toastComponent: AccessibleToastComponent
                },
                'info');
            }),
            catchError((error: any) => {
              this.toastr.show(this.translateService.instant(this.toasterMessage.error || 'toast.error'),
                this.translateService.instant(this.toasterMessage.errorTitle || 'toast.errorTitle'), {
                  positionClass: 'toast-top-right',
                  toastComponent: AccessibleToastComponent
                },
                'error');
              this.LOG.error(error);
              throw error;
            })
          );
    } else {
      let containDuplicableObjects = false;
      Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
        const duplicableObjects = JSON.parse(sessionStorage.getItem(key));
        if (duplicableObjects && avis.jsonSaisieFormulaire.ann[firstItemName]) {
          containDuplicableObjects = true;
          avis.jsonSaisieFormulaire.ann[firstItemName] = this.eformDataService.addObjectsAtPath(avis.jsonSaisieFormulaire.ann[firstItemName], value, duplicableObjects);
        }
      });
      const lotArray = this.eformDataService.getFormArrayFromNoticeValue(
        DuplicableElementPartialPathsEnum['GR-Lot'], avis.jsonSaisieFormulaire.ann[firstItemName]);
      // 🔧 FIX Firefox 2026-04-08: Assigner un ID "LOT-XXXX" aux lots sans ID avant le create.
      if (Array.isArray(lotArray)) {
        let lotCounter = 1;
        lotArray.forEach((lot: any) => {
          if (lot) {
            if (!lot.id) {
              lot.id = { val: 'LOT-' + String(lotCounter).padStart(4, '0') };
            } else if (!lot.id.val) {
              lot.id.val = 'LOT-' + String(lotCounter).padStart(4, '0');
            }
          }
          lotCounter++;
        });
      }
      // 🔧 FIX 2026-04-15: Ajouter un template à l'index 0.
      // Le backend attend TOUJOURS le premier élément (index 0) comme template (init).
      // Sans template, le backend consomme le premier lot réel comme init → LOT-0001 perdu.
      // ATTENTION : N'ajouter le template QUE si le tableau ne contient que les lots de session.
      // Si le formulaire a déjà initialisé procurementprojectlot avec un lot vide (cas F16),
      // ce lot vide sert naturellement de template à l'index 0 → ne pas en ajouter un 2ème.
      const sessionLots = JSON.parse(sessionStorage.getItem('GR-Lot'));
      const sessionLotCount = sessionLots ? sessionLots.length : 0;
      // 🔧 FIX Firefox 2026-04-22 : Sur Firefox, lotArray peut déjà contenir le lot issu du
      // formulaire (avec id.inputId en camelCase) AVANT que addObjectsAtPath ait fusionné les
      // lots de session. Dans ce cas, lotArray.length (1) <= sessionLotCount (5) = true et le
      // template serait inséré à tort, dupliquant LOT-0001 → erreurs P-0004 schematron.
      // Solution : ne pas insérer le template si le premier élément vient du formulaire,
      // détectable par la présence de id.inputId (camelCase) — absent dans les lots de session.
      const firstLotIsFromForm = Array.isArray(lotArray) && lotArray.length > 0 && lotArray[0]?.id?.inputId;
      if (containDuplicableObjects && Array.isArray(lotArray) && lotArray.length > 0
          && sessionLotCount > 0 && lotArray.length <= sessionLotCount && !firstLotIsFromForm) {
        // 🔧 FIX 2026-04-22 (Firefox) : Au lieu d'un template LOT-0000 vide (nullifié),
        // on utilise une COPIE du premier lot de session (LOT-0001) comme template à [0].
        //
        // Contexte : Chrome envoie [LOT-0001(form=template), LOT-0001(session), LOT-0002..N].
        // [0] et [1] ont le même ID LOT-0001 → le backend reconnaît [0] comme template
        // et [1..N] comme les vrais lots → aucun P-0004.
        //
        // Avant ce fix, Firefox insérait LOT-0000 (vide) comme template → le backend recevait
        // [LOT-0000, LOT-0001(form?), LOT-0001(session), LOT-0002..N] → duplication LOT-0001
        // en positions non-template → P-0004 sur [1],[2],[3],[4] → fieldId="" → pas de messages rouges.
        //
        // Avec ce fix, Firefox envoie [LOT-0001(copie session=template), LOT-0001(session), LOT-0002..N]
        // → même structure qu'en Chrome → backend traite [0] comme template → P-0004 éliminé.
        let sessionLotTemplate: any = JSON.parse(JSON.stringify(lotArray[0]));
        lotArray.unshift(sessionLotTemplate);
      }
      return this.formulaireServiceService.create(avis, referenceAvisParent, containDuplicableObjects).pipe(
        // 🔧 FIX Firefox 2026-04-07: Remplacer map() par switchMap() pour ATTENDRE la fin de
        // getAvisWithAllDuplicablesElements avant de retourner data au stepper.
        // Ancien comportement (map) : getAvisWithAllDuplicablesElements était lancé sans être attendu.
        // Sur Firefox (event loop plus rapide), prepareIdSchemeListSubject → getIdsAndNamesByAvisId
        // s'exécutait AVANT que le backend n'ait indexé les 3 lots du pré-remplissage →
        // /list-ids retournait 1 seul lot → addLotsToStepper(1) au lieu de addLotsToStepper(3).
        // Nouveau comportement (switchMap) : on attend getAvisWithAllDuplicablesElements (qui charge
        // l'avis complet du backend avec ses lots indexés) avant de rendre la main au stepper.
        // Ainsi, quand prepareIdSchemeListSubject → getIdsAndNamesByAvisId est appelé,
        // le backend a déjà indexé les 3 lots et /list-ids retourne bien 3 → addLotsToStepper(3).
        switchMap((data) => {
          this.eformDuplicableEntityService.isFirstSaveAndPreremp.next(true);
          this.eformDuplicableEntityService.isCreationButBeforeFirstSave.next(false);
          if (!data) {
            this.toastr.show(this.translateService.instant(this.toasterMessage.error || 'toast.error'),
              this.translateService.instant(this.toasterMessage.errorTitle || 'toast.errorTitle'), {
                positionClass: 'toast-top-right',
                toastComponent: AccessibleToastComponent
              },
              'error');
            throw new Error('Erreur lors de l\'insertion de l\'avis en BDD');
          }
          // 🔧 FIX 2026-04-10: Pour les formulaires non-eForms (MAPA, FNSimple, Divers, Adapté…),
          // firstItemName est undefined (absent de ENoticeTypeXsd) → firstItemName.toLowerCase() crasherait.
          // Court-circuit : on affiche directement le toast de succès et on retourne data.
          if (!firstItemName) {
            this.toastr.show(this.translateService.instant(this.toasterMessage.saveSuccess || 'toast.saveSuccess'),
              this.translateService.instant(this.toasterMessage.saveSuccessTitle || 'toast.saveSuccessTitle'),
              { positionClass: 'toast-top-right', toastComponent: AccessibleToastComponent },
              'info');
            return of(data);
          }
          // 🔧 FIX Firefox 2026-04-08: Polling jusqu'à ce que tous les lots soient indexés en BDD.
          // Sur Chrome : backend retourne 4 items dès le 1er appel (backendCount=4) → 1 seul appel.
          // Sur Firefox : backend indexe les lots de façon asynchrone → backendCount=2 au 1er appel.
          //   On retente toutes les 500ms jusqu'à max 5 fois (2.5s) avant de passer quand même.
          const sessionLotCount = JSON.parse(sessionStorage.getItem('GR-Lot'))?.length ?? 0;
          const expectedLotCount = sessionLotCount + 1; // +1 pour le template à l'index 0

          const pollUntilLotsReady = (attempt: number): Observable<void> =>
            this.eformDuplicableEntityService.getAvisWithAllDuplicablesElements(data.avisId).pipe(
              switchMap(() => {
                const avis = this.eformDuplicableEntityService.avisWithElementsDuplicable.getValue();
                const lots = this.eformDataService.getFormArrayFromNoticeValue(
                  DuplicableElementPartialPathsEnum['GR-Lot'],
                  avis?.jsonsaisieformulaire?.ann?.[firstItemName?.toLowerCase()]
                );
                const count = Array.isArray(lots) ? lots.length : 0;
                if (count >= expectedLotCount || attempt >= 3) {
                  return of(undefined as void);
                }
                return timer(500).pipe(switchMap(() => pollUntilLotsReady(attempt + 1)));
              })
            );

          return pollUntilLotsReady(0).pipe(
            tap(() => {
              // Nettoyer les lots du JSON global pour éviter les doublons lors de la prochaine sauvegarde
              const avisWithElementsDuplicable = this.eformDuplicableEntityService.avisWithElementsDuplicable.getValue();
              if (avisWithElementsDuplicable) {
                Object.entries(DuplicableElementPartialPathsEnum).forEach(([key, value]) => {
                    const duplicableObjects = JSON.parse(sessionStorage.getItem(key));
                    if (duplicableObjects) {
                      const targetObject = firstItemName
                        ? avisWithElementsDuplicable.jsonsaisieformulaire.ann[firstItemName.toLowerCase()]
                        : undefined;
                      if (targetObject) {
                        const currentArray = this.eformDataService.getFormArrayFromNoticeValue(value, targetObject);
                        const hasExtraTemplate = Array.isArray(currentArray) && currentArray.length > duplicableObjects.length;
                        if (hasExtraTemplate) {
                          avisWithElementsDuplicable.jsonsaisieformulaire.ann[firstItemName?.toLowerCase()] = this.eformDataService.clearArrayAtPath(targetObject, value.toLocaleLowerCase(), true);
                        }
                      }
                    }
                  });
                this.eformDuplicableEntityService.avisWithElementsDuplicable.next(avisWithElementsDuplicable);
              }
            }),
            map(() => {
              this.toastr.show(this.translateService.instant(this.toasterMessage.saveSuccess || 'toast.saveSuccess'),
                this.translateService.instant(this.toasterMessage.saveSuccessTitle || 'toast.saveSuccessTitle'),
                {
                  positionClass: 'toast-top-right',
                  toastComponent: AccessibleToastComponent
                },
                'info');
              return data;
            })
          );
        })
      );
    }
  }

  /**
   * 🔧 FIX 2026-04-15: Vide récursivement toutes les propriétés 'val' d'un objet JSON.
   * Utilisé pour créer un template lot vierge à partir de la structure d'un lot pré-rempli.
   * Préserve la structure complète de l'objet (clés, tableaux, objets imbriqués)
   * mais met toutes les valeurs 'val' à null.
   */
  private nullifyValues(obj: any): any {
    if (obj === null || obj === undefined) {
      return obj;
    }
    if (Array.isArray(obj)) {
      return obj.map(item => this.nullifyValues(item));
    }
    if (typeof obj === 'object') {
      const result: any = {};
      for (const key of Object.keys(obj)) {
        if (key === 'val') {
          result[key] = null;
        } else {
          result[key] = this.nullifyValues(obj[key]);
        }
      }
      return result;
    }
    return obj;
  }

  /**
   * Pour ajouter un troisième comportement qui est de décliquer le radio bouton sans passer à l'autre valeur, il a fallu changer les valeurs par défaut (en dur dans la v1)
   * Elles sont remplacées ici, à la toute fin, par les valeurs attendues.
   *
   * @private
   */
  private updateBooleanValueFromAvis(avis) {
    //Simplifié initial
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.communication?.urlSecurite?.non === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.communication?.urlSecurite?.oui === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.communication.urlSecurite.non = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.organisme?.grpCommandes?.oui === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.organisme?.grpCommandes?.non === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.organisme.grpCommandes.non = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.communication?.docSecurite?.oui === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.communication?.docSecurite?.non === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.communication.docSecurite.oui = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.nbCandidatReduit?.oui === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.nbCandidatReduit?.non === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.procedure.nbCandidatReduit.non = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.attributionSansNegociation?.non === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.attributionSansNegociation?.oui === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.procedure.attributionSansNegociation.non = true;
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.variantes?.non === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.procedure?.variantes?.oui === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.procedure.variantes.non = true;
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.tranches?.non === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.tranches?.oui === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.natureMarche.tranches.non = true;
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.reservationMarche?.oui === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.reservationMarche?.non === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.natureMarche.reservationMarche.non = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.informComplementaire?.oui === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.informComplementaire?.non === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.informComplementaire.non = '';
    }
    if (avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.lotsMarche?.non === null && avis.jsonSaisieFormulaire.ann?.fnSimple?.initialFromFNSimple?.natureMarche?.lotsMarche?.oui === null) {
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.natureMarche.lotsMarche.non = true;
      avis.jsonSaisieFormulaire.ann.fnSimple.initialFromFNSimple.isMarcheAlloti = false;
    }
    if (avis.jsonSaisieFormulaire.ann?.divers?.initial?.marcheUnique === 'Oui') {
      avis.jsonSaisieFormulaire.ann.divers.initial.marcheUnique = null;
    } else if (avis.jsonSaisieFormulaire.ann?.divers?.initial?.marcheUnique === 'Non' || avis.jsonSaisieFormulaire.ann?.divers?.initial?.marcheUnique === null) {
      avis.jsonSaisieFormulaire.ann.divers.initial.marcheUnique = '';
    }
    return avis;
  }
}
